import script from "./LoginIntroduce.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginIntroduce.vue?vue&type=script&lang=ts&setup=true"

import "./LoginIntroduce.vue?vue&type=style&index=0&id=6fac32c5&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fac32c5"]])

export default __exports__